module.exports = __webpack_public_path__ + "static/img/Shine.32074f25.svg";